export const hasSufficientWalletBalance = (amount: number, walletBalance: number) => {
  return walletBalance >= amount
}
